import { rupees } from 'config/utils';
import sanitizePaymentOptions, {
  getSupportedPaymentInstruments,
} from './paymentOptions';

import {
  getIsMobileDevice,
} from 'utils/ModernizrUtils';

const getCartInitialState = (state, baseInitialState = {}) => {
  const {
    should_retry: shouldRetry,
  } = state;

  const paymentInstruments = getSupportedPaymentInstruments(
    (state.payment && state.payment.payment_forms) || {}
  );

  const amount = shouldRetry ? state.payment.amount : 0;

  return {
    ...baseInitialState,
    totalAmountFormatted: rupees(amount),
    isMobileDevice: getIsMobileDevice(),
    ...sanitizePaymentOptions(paymentInstruments),
  };
};

export default getCartInitialState;



// WEBPACK FOOTER //
// ./src/payments/reducers/finalize/cartInitialState.js